// extracted by extract-css-chunks-webpack-plugin
module.exports = {"subtitle":"x07P32qBoB4l1kbOIe8Y","submit":"QdMqTfj7fF9zO_Yt8l16"};